export const SkillType = {
  PROMPT_TEMPLATE: 'prompt_template',
  TOOL_CONFIG: 'tool_config',
  WORKFLOW: 'workflow',
} as const;

export type SkillType = (typeof SkillType)[keyof typeof SkillType];

export const SkillScope = {
  GLOBAL: 'global',
  PROJECT: 'project',
} as const;

export type SkillScope = (typeof SkillScope)[keyof typeof SkillScope];

export interface SkillVariable {
  name: string;
  description: string;
  defaultValue?: string;
  required: boolean;
}

export interface Skill {
  id: string;
  name: string;
  description: string | null;
  type: SkillType;
  scope: SkillScope;
  content: string | null;
  configuration: Record<string, unknown> | null;
  variables: SkillVariable[] | null;
  userId: string;
  projectId: string | null;
  createdAt: string;
  updatedAt: string;
  _resolved?: {
    content: string | null;
    configuration: Record<string, unknown> | null;
    variables: SkillVariable[] | null;
    enabled: boolean;
  };
}

export interface CreateSkillDto {
  name: string;
  description?: string;
  type: SkillType;
  scope?: SkillScope;
  content?: string;
  configuration?: Record<string, unknown>;
  variables?: SkillVariable[];
}

export interface UpdateSkillDto {
  name?: string;
  description?: string | null;
  type?: SkillType;
  scope?: SkillScope;
  content?: string | null;
  configuration?: Record<string, unknown> | null;
  variables?: SkillVariable[] | null;
}
